<template>
<div class="pensiones">
  <md-progress-bar md-mode="indeterminate" v-if="loading"/>
  <div id="pensionchart"></div>
</div>
</template>

<script>
export default {
  mounted(){
    google.charts.load('current', {'packages':['corechart']})
    google.charts.setOnLoadCallback(this.drawChart)
  },
  props: ["dataChart"],
  data() {
    return {
      loading: true
    }
  },
  methods: {
    drawChart(){
      console.log(this.dataChart);
      var dataPension = this.dataChart.data.map(d => {
        var legend = d.pensionSystemType == "02" ? "ONP" : this.dataChart.legend[d.pensionSystemType]
        return [
          legend,d.sublegend["01"]?d.sublegend["01"]:0,d.sublegend["02"]?d.sublegend["02"]:0,d.sublegend["03"]?d.sublegend["03"]:0,d.sublegend["undefined"]?d.sublegend["undefined"]:0
        ]
      })
      var allDataPension = [['Sistema Pensionario', this.dataChart.sublegend["01"], this.dataChart.sublegend["02"], this.dataChart.sublegend["03"], "ONP"],...dataPension]
      // var data = google.visualization.arrayToDataTable([
      //   ['Sistema Pensionario','Flujo', "Mixto", "Mixto-Flujo", "ONP"],
      //   ['Habitat',1,2,0,0],
      //   ['Integra',2,1,1,0],
      //   ['Prima',1,1,1,0],
      //   ['ProFuturo',0,1,1,0],
      //   ['ONP',0,0,0,2]
      // ])
      var data = google.visualization.arrayToDataTable(allDataPension)
      var options = {
        title: 'Sistema de Pensiones',
        legend: window.innerWidth < 1200 ? 'top' : 'right',
        hAxis: {title: "Sistema de Pensiones", titleTextStyle: {color: '#2c2c2c'}},
        colors: ['#c1dadf','#97c2c9','#799ba1', '#5b7479']
        // slices: {
        //   0: {color: '#55d8fe'},
        //   1: {color: '#ff8373'},
        //   2: {color: '#ffda83'},
        //   3: {color: '#5FE3A1'},
        //   4: {color: '#a3a0fb'}
        // }
      }
      var chart = new google.visualization.ColumnChart(document.getElementById('pensionchart'))

      chart.draw(data, options)
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
$b-blue-dark: #C63832;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: '../assets/img/';

//2-VENDORS

//3-TOOLS
//functions
//background-image function
@function bimg($img){
  @return url($p-img+$img);
}
//mixins
@mixin mqwh($min-width,$max-height){
  @media (min-width: $min-width) and (max-height: $max-height){
    @content;
  }
}

@mixin mq($min-width){
  @media screen and (min-width: $min-width){
    @content;
  }
}

//8-TRUMPS
#pensionchart{
  width: 360px;
  height: 200px;
  @include mq('700px'){
    width: 47rem;
    height: 19rem;
  }
  @include mq($md){
    width: 39rem;
  }
  @include mq('990px'){
    width: 47rem
  }
  @include mq($lg){
    width: calc(525px + 21rem)
  }
}

.pensiones{
  padding: 2rem 0;
  background-color: #fff;
  border-radius: .6rem;
}
</style>
